export default class SessionStorage {
  static getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      console.error('Session Storage not available.'); //  eslint-disable-line no-console
      return null;
    }
  }

  static setItem(key, value) {
    try {
      return sessionStorage.setItem(key, value);
    } catch (err) {
      console.error('Session Storage not available.'); //  eslint-disable-line no-console
    }
  }
}
